module.exports = __webpack_public_path__ + "static/media/credit.4ed13fcc.svg";